<div fxLayout="row">
  <div fxFlex="70">
    <div fxLayout="column" class="stats-graph">
      <div fxLayout="row" fxLayoutAlign="center center" class="chart-view">
        <ngx-charts-pie-chart *ngIf="statisticsData.length > 0; else nodata" [scheme]="colorScheme" [results]="statisticsData"
          [legend]="false" [labels]="false" [doughnut]="true" [arcWidth]="0.55">
        </ngx-charts-pie-chart>
        <ng-template #nodata>
          {{'statistics_chart.no_calls' | translate}}
        </ng-template>
      </div>
      <div fxLayout="row">
        <div fxFlex="33" fxLayout="column" fxLayoutAlign="center center">
          <h1>{{answeredCallNo}}</h1>
          <span layout-padding>
            <div class="square answeredCallColor"></div>{{'statistics_chart.answered' | translate}}
          </span>
          <div>
            <strong>{{answeredCallPercentage}}%</strong>
          </div>
        </div>
        <div fxFlex="33" fxLayout="column" fxLayoutAlign="center center">
          <h1>{{unAnsweredCallNo}}</h1>
          <span layout-padding>
            <div class="square unAnsweredCallColor"></div>{{'statistics_chart.unanswered' | translate}}
          </span>
          <div>
            <strong>{{unAnsweredCallPercentage}}%</strong>
          </div>
        </div>
        <div fxFlex="33" fxLayout="column" fxLayoutAlign="center center">
          <h1>{{aHangupCallNo}}</h1>
          <span layout-padding>
            <div class="square aHangupCallColor"></div>{{'statistics_chart.hung_up' | translate}}
          </span>
          <div>
            <strong>{{aHangupCallPercentage}}%</strong>
          </div>
        </div>
      </div>
      </div>
      </div>
      <div fxFlex="30" fxLayout="column" class="stats-data">
        <h1>{{numberOfCalls}}</h1>
        <span>{{'statistics_chart.incoming_calls' | translate}}</span>
        <br />
        <br />
        <h1>{{ averageCallDuration | durationFormatter}}
        </h1>
        <span>{{'statistics_chart.avg_call_duration' | translate}}</span>
      </div>
      </div>